import * as THREE from 'three';
import { SETTINGS } from '../SETTINGS';

export const createCamera = (aspect: number) => {
  const camera = new THREE.PerspectiveCamera(
    SETTINGS.CAMERA.FOV,
    aspect,
    SETTINGS.CAMERA.NEAR,
    SETTINGS.CAMERA.FAR
  );
  camera.position.set(0, 0, 10);
  camera.lookAt(0, 0, 0);
  return camera;
};

export const createRenderer = (canvas: HTMLCanvasElement) => {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    alpha: true,
    antialias: true
  });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setClearColor(0x111111, 1.0);
  return renderer;
};

export const createScene = () => {
  const scene = new THREE.Scene();
  scene.background = null; // 透明な背景
  return scene;
};